import { Grid } from "@mui/material";
import Breadcrumb from "@Components/breadcrumb/Breadcrumb";
import { withAsync } from "@Libs/api/withAsync";
import { SnackBarType } from "@Types/SnackBar";
import { submitContactUsForm } from "@wff/api/customerApi";
import { useBreadcrumb } from "@wff/hooks/useBreadcrumb";
import { triggerSnackBar } from "@wff/store/SnackBarSlice";
import { useAppDispatch } from "store/hooks";
import { IContactUsContent } from "types/contact-us-page";
import { ContactUsProvider } from "../../context/contactUs/ContactUsProvider";
import { ContactUsCommunicate } from "./ContactUsCommunicate";
import { ContactUsForm, ContactUsFormValues } from "./ContactUsForm";
import classes from "./ContactUs.module.scss";

export const ContactUs = (props: IContactUsContent) => {
  const { pageTitle, heading, successMessage, errorMessage } = props;
  const dispatch = useAppDispatch();

  const onContactUsSubmit = async (formValues: ContactUsFormValues) => {
    const { response, error } = await withAsync(() =>
      submitContactUsForm(formValues)
    );

    const success = !error && response?.status === 201;
    const snackBarData = {
      message: success ? successMessage : errorMessage,
      type: success ? SnackBarType.SUCCESS : SnackBarType.ERROR,
    };
    dispatch(triggerSnackBar(snackBarData));
  };
  useBreadcrumb({ currentSlug: { title: pageTitle, link: "" } });

  return (
    <div className={classes["contact-us-page"]}>
      <h1 className={classes["heading"]}>{heading}</h1>
      <Breadcrumb />
      <section className={classes["contact-section"]}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <ContactUsCommunicate {...props} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ContactUsProvider>
              <ContactUsForm {...props} onSubmit={onContactUsSubmit} />
            </ContactUsProvider>
          </Grid>
        </Grid>
      </section>
    </div>
  );
};
